import { isStatusCodeError } from '@confluence/error-types/entry-points/isStatusCodeError.ts';
import { isTooManyRequestsError } from '@confluence/error-types/entry-points/isTooManyRequestsError.ts';
import { isUnauthorizedError as isUnauthenticatedError } from '@confluence/error-types/entry-points/isUnauthorizedError.ts';

// Deliberately excludes generic network failures ("Failed to fetch" / "NetworkError" /
// "Load failed") - those should keep being reported.
const KNOWN_EXPECTED_ERROR_MESSAGES = [
	'not listed in the IP allowlist',
	'Auth category: UNAUTHENTICATED is not allowed in service knowledge_discovery',
	'does not support customer accounts',
	'Step-up authentication is required',
	'rate limit exceeded',
];

type AutohighlightsGraphQLErrorLike = {
	message?: string;
	extensions?: Record<string, unknown>;
};

type AutohighlightsErrorLike = AutohighlightsGraphQLErrorLike & {
	graphQLErrors?: readonly AutohighlightsGraphQLErrorLike[];
};

const matchesKnownExpectedMessage = (errorLike: AutohighlightsGraphQLErrorLike): boolean =>
	KNOWN_EXPECTED_ERROR_MESSAGES.some((message) => errorLike.message?.includes(message));

export const isExpectedAutohighlightsError = (
	error: AutohighlightsErrorLike | null | undefined,
): boolean => {
	if (!error) {
		return false;
	}

	const isExpectedMessage = error.graphQLErrors?.length
		? error.graphQLErrors.every(matchesKnownExpectedMessage)
		: matchesKnownExpectedMessage(error);

	if (isExpectedMessage) {
		return true;
	}

	return (
		isUnauthenticatedError(error as Error) ||
		isStatusCodeError(error as Error, '403') ||
		isTooManyRequestsError(error as Error)
	);
};
